import Navbar from "./Components/Navbar/navbar";
import Header from "./Components/Header/header";
import Skills from "./Components/Skills/skills";
import Work from "./Components/Work/work";
import Footer from "./Components/Footer/footer";
function App() {
  return (
    <div className="App">
      <Navbar/>
      <Header/>
      <Skills/>
      <Work/>
      <Footer/>
      
    </div>
  );
}

export default App;
